import { useEffect } from 'react'
import useCourses from '@hooks/useCourses'
import { SelectSearchFieldParams } from '@templates/AddNewItemModal/templates/selectSearchField'
import { Field } from '@templates/AddNewItemModal/Content'
import { selectSearchField } from '@templates/AddNewItemModal/templates'
import { FilterState } from '@hooks/useItemsFilters'

const useCoursesSelectField = (forcedFilters?: FilterState): ((
  params: Partial<SelectSearchFieldParams> & { name: string; label: string }
) => Field) => {
  const {
    data: coursesData,
    isLoading: coursesIsLoading,
    setPage,
    setFilters,
  } = useCourses({ forcedFilters })
  const { items: courses = [], length = 0 } = coursesData || {}

  useEffect(() => {
    setPage(1)
  }, [forcedFilters, setPage])

  return (params) =>
    selectSearchField({
      ...params,
      options: courses,
      isLoading: coursesIsLoading,
      setFilters,
      setPage,
      length,
      dropdownWidth: 500,
    })
}

export default useCoursesSelectField
